import { render, staticRenderFns } from "./PersonalSettings.vue?vue&type=template&id=51994c5f&scoped=true&"
import script from "./PersonalSettings.vue?vue&type=script&lang=js&"
export * from "./PersonalSettings.vue?vue&type=script&lang=js&"
import style0 from "./PersonalSettings.vue?vue&type=style&index=0&id=51994c5f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51994c5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VForm,VRow,VSheet,VTextField})
